import { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import PhotoUploadFailed from 'components/ModalViews/PhotoUploadFailed'
import Dropzone from 'components/Dropzone'
import { CDN, CLOUDINARY_PRESETS } from 'utils/constants'
import { useScript, useUniqueID } from 'utils/hooks'
import { useAction } from 'utils/actions'

const CloudinaryUpload = props => {
  const uploadWidget = useRef(null)
  const bulkUploadFiles = useRef(null)
  const droppedFiles = useRef(null)
  const [active, setActive] = useState(false)
  const generatedUniqueID = useUniqueID()
  const id = props.id || generatedUniqueID
  const { openModal } = useAction()
  const status = useScript(active ? CDN.CLOUDINARY.URL : '')

  const onOpen = () => {
    if (droppedFiles.current) {
      uploadWidget.current.open(null, { files: droppedFiles.current })
      droppedFiles.current = null
    } else {
      uploadWidget.current.open()
    }
  }

  const handleModeration = result => {
    const reasons = []
    result.info?.moderation?.[0]?.response?.moderation_labels?.forEach(label =>
      reasons.push(label.name)
    )
    openModal(<PhotoUploadFailed reasons={reasons} reopenID={props.reopenID} />)
  }

  const onEvent = (error, result) => {
    if (result.event === 'queues-start') bulkUploadFiles.current = []

    if (result.event === 'queues-end') {
      props.onBulkUploadSuccess(bulkUploadFiles.current)
      bulkUploadFiles.current = null
    }

    if (!error && result?.event === 'success') {
      if (result.info?.moderation?.[0]?.status === 'rejected') {
        handleModeration(result)
      } else {
        bulkUploadFiles.current.push(result)
        props.onUploadSuccess(result)
      }
    }
  }

  useEffect(() => {
    if (status === 'ready' && !props.disable) {
      uploadWidget.current = cloudinary.createUploadWidget(
        {
          ...CDN.CLOUDINARY[props.options],
          uploadPreset: CLOUDINARY_PRESETS[props.preset],
        },
        onEvent
      )
      if (active) onOpen()
    }
  }, [status])

  const handleOnClick = () => {
    if (!props.disable) {
      active ? onOpen() : setActive(true)
    }
  }

  const handleOnDrop = files => {
    if (!props.disable) {
      droppedFiles.current = files
      active ? onOpen() : setActive(true)
    }
  }

  return (
    <Dropzone
      noClick
      accept={['image/png', 'image/jpeg']}
      // onError={setErrorMessage}
      onDrop={handleOnDrop}
      {...props.dropzoneProps}
    >
      <span id={id} onClick={handleOnClick} style={{ position: 'relative' }}>
        {/* {status.loading && <Spinner position="absolute" />} */}
        {props.children}
      </span>
    </Dropzone>
  )
}

CloudinaryUpload.propTypes = {
  id: PropTypes.string,
  preset: PropTypes.oneOf(Object.keys(CLOUDINARY_PRESETS)),
  options: PropTypes.oneOf(Object.keys(CDN.CLOUDINARY)),
  reopenID: PropTypes.string,
  disable: PropTypes.bool,
  onBulkUploadSuccess: PropTypes.func,
  onUploadSuccess: PropTypes.func,
  dropzoneProps: PropTypes.object,
}

CloudinaryUpload.defaultProps = {
  preset: 'DEFAULT',
  options: 'OPTIONS',
  onUploadSuccess: () => {},
  onBulkUploadSuccess: () => {},
  dropdownProps: {},
}

export default CloudinaryUpload
